import React from 'react';
export function StickyHeader() {
  return <div className="sticky top-0 z-40 flex min-h-[36px] w-full items-center justify-center bg-sage px-4 py-2 text-center" data-id="element-179" data-mp="2zb2qzvd4yfy0">
      <p className="text-[11px] font-normal leading-snug text-white sm:text-xs" data-id="element-180" data-mp="14tt0h0epalvt">
        <span className="sm:hidden" data-id="element-181" data-mp="1iqg9i1jxh2i3">🌎 Disponible en toda LATAM · Descarga inmediata</span>
        <span className="hidden sm:inline" data-id="element-182" data-mp="1dsobqqwlqm5z">
          🌎 Disponible para toda LATAM · Descarga inmediata · Pago único · La plataforma convierte el
          precio a tu moneda local automáticamente
        </span>
      </p>
    </div>;
}